import { takeLatest, call, put } from "redux-saga/effects";
import axios from "axios";
import {
  getDroneJobsSuccess,
  getDroneJobsFailure,
  getSingleDroneJobSuccess,
  getSingleDroneJobFailure,
} from "../slice/droneJobsSlice";
const url = process.env.REACT_APP_API_URL;
function* fetchDroneJobs(action) {
  try {
    const response = yield call(() =>
      axios.get(
        `${url}/getAllDroneJob?page=${action.payload.page}&limit=${action.payload.limit}`
      )
    );
    yield put(getDroneJobsSuccess(response.data.data));
  } catch (error) {
    yield put(getDroneJobsFailure(error.message));
  }
}
function* fetchSingleDroneJob(action) {
  try {
    const response = yield call(() =>
      axios.get(`${url}/getSingleDroneJob?droneJobId=${action.payload}`)
    );
    yield put(getSingleDroneJobSuccess(response.data.data));
  } catch (error) {
    yield put(getSingleDroneJobFailure(error.message));
  }
}

export function* watchGetDroneJobs() {
  yield takeLatest("droneJob/getDroneJobs", fetchDroneJobs);
}
export function* watchGetSingleDroneJob() {
  yield takeLatest("droneJob/getSingleDroneJob", fetchSingleDroneJob);
}
